module.exports = `fragment all_news on Contentstack_all_news {
    global_id
    enabled
    heading
    inject_data
    variant
  }`;